import { useEffect, useState } from 'react';

/**
 * Minimal history-based routing.
 *
 * The application has three destinations (day view, admin, display sign-in), so
 * a routing library would be more dependency than the problem warrants.
 */

export function navigate(path, { replace = false } = {}) {
  if (replace) window.history.replaceState({}, '', path);
  else window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function useLocation() {
  const [location, setLocation] = useState(() => ({
    pathname: window.location.pathname,
    search: window.location.search,
  }));

  useEffect(() => {
    function handle() {
      setLocation({
        pathname: window.location.pathname,
        search: window.location.search,
      });
    }
    window.addEventListener('popstate', handle);
    return () => window.removeEventListener('popstate', handle);
  }, []);

  return location;
}
